import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTreatmentIconSecondary from './svgs/TreatmentIconSecondary.js';
import SvgTreatmentIcon from './svgs/TreatmentIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var treatmentIcon = (props => useIcon(SvgTreatmentIcon, SvgTreatmentIconSecondary, props));

export { treatmentIcon as default };
